export function ToCustomDecimal(number) {
   // return number.toFixed(2).replace(".", ",");
    const formattedNumber = number.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    //return formattedNumber.replace(",", " ").replace(".", ",");
    return formattedNumber.replace(/,/g, ' ').replace(/\./g, ',')
}